/* eslint-disable max-lines */
/* eslint-disable react/prop-types */
import { Box, Grid } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import debounceLodash from 'lodash.debounce';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { CustomInput } from '../LeadGeneration/CustomInput/CustomInput';
import { CustomSelect } from '../LeadGeneration/CustomSelect/CustomSelect';
import { CustomAutoComplete } from '../LeadGeneration/CustomAutoComplete/CustomAutoComplete';
import { AddressInformationStyles as classes } from '../LeadGeneration/StepOne/AddressInformationStyles';
import {
  addAutoCompleteCityToDropdownLogin,
  returnCityListLogin,
  returnStateListLogin,
} from './LoginAddressUtils';
import {
  HOME_VI,
  HOME_PR,
  HOMEUS_VI,
  HOMEUS_PR,
  HOME_ADDRESS_TITLE_COMMERCIAL,
  REQUIRED,
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COUNTRY,
  STATE,
  CITY,
  ZIPCODE,
  MANDATORY_FIELD_ERR,
  EN,
  COUNTRY_ES_BUNDLE,
  COUNTRY_ES,
} from '../../constants';
import { commonTernary, fetchAddressLookup, isBundle, zipCodeValueSetError } from '../commonCode';
import { BusinessAccountInfoStyles as styledClasses } from '../CommercialDeposit/BusinessAccountInfoStyles';

const LoginHomeAddress = (props) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const [addressLookupDataResponse, setAddressLookupDataResponse] = useState({});
  const [addressLookupData, setAddressLookupData] = useState([]);
  const { handleChange } = props;

  const {
    setCurrentPage,
    loginHomeAddress,
    setLoginHomeAddress,
    loginHomeAddressErrors,
    setLoginHomeAddressErrors,
    setIsEtbAddressDirty,
    callLookupApi,
    setCallLookupApi,
    setCallLookupApiHome,
    setCallLookupApiEmp,
    setCallLookupApiHomeSelfEmp,
    flowTypeETB,
    productName,
    language,
  } = leadGenerationContext;
  useEffect(() => {
    setCurrentPage('login-home-address');
  }, []);
  const stateChange = (addressObject, country) => {
    let data;
    if (addressObject.Address.State) {
      if (country === HOME_VI || country === HOME_PR) {
        data = 'N/A';
      } else {
        data = addressObject.Address.State;
      }
    }
    return data;
  };
  const handleAutoCompleteData = (addressObject) => {
    setIsEtbAddressDirty(true);

    if (addressObject) {
      let city = '';
      let state = '';
      let country = '';
      let zipCode = '';
      let address1 = '';
      if (
        addressObject.Address.AddressLine1 ||
        addressObject.Address.PostalCode ||
        addressObject.Address.City
      ) {
        address1 = addressObject.Address.AddressLine1;
        zipCode = addressObject.Address.PostalCode.split('-')[0];
        city = addressObject.Address.City;
      }

      if (addressObject?.Address?.AddressLine1?.length > 30) {
        setLoginHomeAddressErrors((prevState) => ({
          ...prevState,
          address1: '* Address Line 1 should have max 30 characters.',
          city: '',
          country: '',
          state: '',
          zipCode: '',
        }));
      } else {
        setLoginHomeAddressErrors((prevState) => ({
          ...prevState,
          address1: '',
          city: '',
          country: '',
          state: '',
          zipCode: '',
        }));
      }
      if (addressObject.Address.CountrySubdivisionCode === HOMEUS_PR) {
        country = 'PR';
      } else if (addressObject.Address.CountrySubdivisionCode === HOMEUS_VI) {
        country = 'VI';
      } else {
        country = 'USA';
      }
      state = stateChange(addressObject, country);

      const cityPresent = addAutoCompleteCityToDropdownLogin(country, state, city);
      if (!cityPresent) {
        setLoginHomeAddress((prevState) => ({
          ...prevState,
          missingAutoCompleteCity: city,
        }));
      }
      setLoginHomeAddress((prevState) => ({
        ...prevState,
        address1,
        city,
        country,
        state,
        zipCode,
      }));
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        city: '',
        country: '',
        state: '',
        zipCode: zipCodeValueSetError(zipCode),
      }));
    }
  };

  const handleAddressLineOneChange = (address1) => {
    setIsEtbAddressDirty(true);
    const input = 'address1';
    if (address1 && address1.length > 0 && address1.length <= 30) {
      if (address1.match(/^[A-Za-z0-9'#@%&\\/.\-\s,]+$/) && address1?.length >= 2) {
        setLoginHomeAddress((prevState) => ({
          ...prevState,
          [input]: address1,
        }));
        setLoginHomeAddressErrors((prevState) => ({
          ...prevState,
          [input]: '',
        }));
      } else {
        setLoginHomeAddress((prevState) => ({
          ...prevState,
          [input]: address1,
        }));
        setLoginHomeAddressErrors((prevState) => ({
          ...prevState,
          [input]: '* Invalid address',
        }));
      }
    } else if (address1 && address1.length > 30) {
      setLoginHomeAddress((prevState) => ({ ...prevState, [input]: address1 }));
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        [input]: '* Address Line 1 should have max 30 characters.',
      }));
    } else {
      setLoginHomeAddress((prevState) => ({
        ...prevState,
        [input]: address1 || '',
      }));
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        [input]: MANDATORY_FIELD_ERR,
      }));
    }
  };

  const debounceFunc4 = debounceLodash((address1, country, query4, accessToken) => {
    fetchAddressLookup(
      address1,
      country,
      query4,
      accessToken,
      setAddressLookupData,
      setAddressLookupDataResponse,
      setCallLookupApi,
      setCallLookupApiHome,
      setCallLookupApiEmp,
      setCallLookupApiHomeSelfEmp
    );
  }, 500);

  const fetchAddress4 = useCallback(debounceFunc4, []);

  useEffect(() => {
    let query4 = '';
    if (loginHomeAddress?.address1) {
      query4 += `${loginHomeAddress.address1} `;
    }
    if (loginHomeAddress?.address2) {
      query4 += `${loginHomeAddress.address2} `;
    }
    if (loginHomeAddress?.state) {
      query4 += `${loginHomeAddress.state} `;
    }
    if (loginHomeAddress?.city) {
      query4 += `${loginHomeAddress.city} `;
    }
    if (loginHomeAddress?.zipCode) {
      query4 += `${loginHomeAddress.zipCode} `;
    }
    const address1 = loginHomeAddress?.address1 ? loginHomeAddress.address1 : '';
    const country = loginHomeAddress?.country ? loginHomeAddress.country : '';
    if (callLookupApi) {
      fetchAddress4(address1, country, query4, leadGenerationContext.accessToken);
    }
  }, [leadGenerationContext?.accessToken, loginHomeAddress?.address1]);

  let errorMessage;
  const mesgForCountrySel = () => {
    if (loginHomeAddressErrors?.country) {
      errorMessage = t(loginHomeAddressErrors.country, {
        defaultValue: loginHomeAddressErrors.country,
      });
    } else if (loginHomeAddress?.country === 'VI') {
      errorMessage = t('DefaultCountryPR', {
        defaultValue: 'You must be a Puerto Rico resident to open this account.',
      });
    } else {
      errorMessage = '';
    }
    return errorMessage;
  };

  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 12 }}>
        <Grid
          container
          size={{ md: 12 }}
          spacing={0}
          sx={styledClasses.idDescriptionOne}
          style={{ padding: '0px' }}
        >
          <Grid size={{ xs: 12, md: 12 }}>
            <Grid size={{ xs: 12 }}>
              <CustomAutoComplete
                id="address1"
                dataTestIdAutocomplete="autocomplete_address1"
                dataTestIdForLabel="homeAddress1"
                dataTestIdForInput="addr1Input"
                required={!isBundle(productName)}
                isBundle={isBundle(productName)}
                inputLabelAriaLabel={`${t(HOME_ADDRESS_TITLE_COMMERCIAL, {
                  defaultValue: HOME_ADDRESS_TITLE_COMMERCIAL,
                })} region ${t(ADDRESS_LINE1, {
                  defaultValue: ADDRESS_LINE1,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={
                  <span
                    style={{
                      color:
                        isBundle(productName) && loginHomeAddressErrors?.address1
                          ? 'red'
                          : 'inherit',
                    }}
                  >
                    {t(ADDRESS_LINE1, { defaultValue: ADDRESS_LINE1 })}
                  </span>
                }
                options={
                  addressLookupData &&
                  loginHomeAddress?.address1 &&
                  loginHomeAddress.address1?.length >= 6
                    ? addressLookupData
                    : []
                }
                value={loginHomeAddress?.address1 ? loginHomeAddress.address1 : ''}
                handleChange={(_event, selectedValue) => {
                  setCallLookupApi(true);
                  if (loginHomeAddress?.address1 && loginHomeAddress.address1?.length >= 6) {
                    const index = addressLookupData?.indexOf(selectedValue);
                    const selectedObj = addressLookupDataResponse?.data?.Results[index];
                    handleAutoCompleteData(selectedObj);
                  }
                }}
                handleInputChange={(event, newInputValue) => {
                  if (event) {
                    setCallLookupApi(true);
                    handleAddressLineOneChange(newInputValue);
                  }
                }}
                filterOptions={(options) => options}
                maxLength={30}
                autoFocus={false}
                placeholder={t('Enter Address Details', {
                  defaultValue: 'Enter Address Details',
                })}
                fullWidth
                error={loginHomeAddressErrors?.address1}
              />
              <Box component="span" role="alert" sx={classes.error_message}>
                {t(loginHomeAddressErrors?.address1, {
                  defaultValue: loginHomeAddressErrors?.address1,
                })}
              </Box>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }} sx={styledClasses.inputs_grid_margin_HA}>
            <Grid size={{ xs: 12 }}>
              <CustomInput
                optional
                dataTestId="address_testid"
                id="address2"
                dataTestIdForLabel="homeAddress2"
                required={false}
                isBundle={isBundle(productName)}
                inputLabelAriaLabel={`${t(ADDRESS_LINE2, {
                  defaultValue: ADDRESS_LINE2,
                })}`}
                label={t(ADDRESS_LINE2, {
                  defaultValue: ADDRESS_LINE2,
                })}
                autoFocus={false}
                handleChange={handleChange}
                placeholder={t('Enter Address Details', {
                  defaultValue: 'Enter Address Details',
                })}
                fullWidth
                inputProps={{ maxLength: 30 }}
                value={loginHomeAddress?.address2 ? loginHomeAddress.address2 : ''}
                error={loginHomeAddressErrors?.address2 ? loginHomeAddressErrors.address2 : ''}
              />
              <Box component="span" role="alert" sx={classes.error_message}>
                {t(loginHomeAddressErrors?.address2, {
                  defaultValue: loginHomeAddressErrors?.address2,
                })}
              </Box>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }} sx={styledClasses.inputs_grid_margin_HA}>
            <Grid size={{ xs: 12 }}>
              <CustomSelect
                id="country"
                dataTestId="country_testid"
                dataTestIdForLabel="homeCountry"
                required={!isBundle(productName)}
                isBundle={isBundle(productName)}
                inputLabelAriaLabel={`${t(COUNTRY, {
                  defaultValue: COUNTRY,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={
                  <span
                    style={{
                      color:
                        isBundle(productName) && loginHomeAddressErrors?.state ? 'red' : 'inherit',
                    }}
                  >
                    {commonTernary(
                      language === EN,
                      t(COUNTRY, { defaultValue: COUNTRY }),
                      isBundle(productName)
                        ? t(COUNTRY_ES_BUNDLE, { defaultValue: 'País' })
                        : t(COUNTRY_ES, { defaultValue: 'País/Región' })
                    )}
                  </span>
                }
                options={['PR', 'USA', 'VI']}
                handleChange={handleChange}
                fullWidth
                value={loginHomeAddress?.country ? loginHomeAddress.country : ''}
                selectAriaLabel={`${t('Aria Label Country', {
                  defaultValue: 'Country Required Choose your country dropdown menu button',
                })}`}
                error={mesgForCountrySel()}
              />
              <Box
                component="span"
                aria-live="polite"
                tabIndex={
                  loginHomeAddress?.country && loginHomeAddress.country !== 'PR' ? '0' : '-1'
                }
                sx={classes.error_message}
              >
                {mesgForCountrySel()}
              </Box>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }} sx={styledClasses.inputs_grid_margin_HA}>
            <Grid size={{ xs: 12 }}>
              <CustomSelect
                id="state"
                dataTestId="state_testid"
                dataTestIdForLabel="homeState"
                required={!isBundle(productName)}
                isBundle={isBundle(productName)}
                inputLabelAriaLabel={`${t(STATE, {
                  defaultValue: STATE,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={
                  <span
                    style={{
                      color:
                        isBundle(productName) && loginHomeAddressErrors?.state ? 'red' : 'inherit',
                    }}
                  >
                    {t(STATE, { defaultValue: STATE })}
                  </span>
                }
                options={returnStateListLogin('state', loginHomeAddress)}
                handleChange={handleChange}
                isState
                fullWidth
                value={loginHomeAddress?.state ? loginHomeAddress.state : ''}
                error={loginHomeAddressErrors?.state}
                selectAriaLabel={`${t('Aria Label State', {
                  defaultValue: 'State Required Choose your state dropdown menu button',
                })}`}
              />
              <Box role="alert" sx={classes.error_message}>
                {t(loginHomeAddressErrors?.state, {
                  defaultValue: loginHomeAddressErrors?.state,
                })}
              </Box>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }} sx={styledClasses.inputs_grid_margin_HA}>
            <Grid size={{ xs: 12 }}>
              <CustomSelect
                id="city"
                dataTestIdForLabel="homeCity"
                dataTestId="city_testid"
                required={!isBundle(productName)}
                isBundle={isBundle(productName)}
                inputLabelAriaLabel={`${t(CITY, {
                  defaultValue: CITY,
                })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`}
                label={
                  <span
                    style={{
                      color:
                        isBundle(productName) && loginHomeAddressErrors?.city ? 'red' : 'inherit',
                    }}
                  >
                    {t(CITY, { defaultValue: CITY })}
                  </span>
                }
                options={returnCityListLogin('city', loginHomeAddress)}
                handleChange={handleChange}
                fullWidth
                value={loginHomeAddress?.city ? loginHomeAddress.city : ''}
                error={loginHomeAddressErrors?.city}
                selectAriaLabel={`${t('Aria Label City', {
                  defaultValue: 'City Required Choose your city dropdown menu button',
                })}`}
              />
              <Box role="alert" sx={classes.error_message}>
                {t(loginHomeAddressErrors?.city, {
                  defaultValue: loginHomeAddressErrors?.city,
                })}
              </Box>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }} sx={styledClasses.inputs_grid_margin_HA}>
            <Grid size={{ xs: 12 }}>
              <CustomInput
                id="zipCode"
                dataTestIdForLabel="homeZipCode"
                dataTestId="zipCode_id"
                required={!isBundle(productName)}
                isBundle={isBundle(productName)}
                autoFocus={false}
                inputLabelAriaLabel={`${t(ZIPCODE, {
                  defaultValue: ZIPCODE,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                placeholder={t('Enter Zip Code', {
                  defaultValue: 'Enter Zip Code',
                })}
                fullWidth
                handleChange={handleChange}
                error={loginHomeAddressErrors?.zipCode ? loginHomeAddressErrors.zipCode : ''}
                inputProps={{ maxLength: flowTypeETB === 'EtbFlow' ? 9 : 5, inputMode: 'numeric' }}
                label={
                  <span
                    style={{
                      color:
                        isBundle(productName) && loginHomeAddressErrors?.zipCode
                          ? 'red'
                          : 'inherit',
                    }}
                  >
                    {t(ZIPCODE, { defaultValue: ZIPCODE })}
                  </span>
                }
                value={loginHomeAddress?.zipCode ? loginHomeAddress.zipCode : ''}
              />
              <Box role="alert" sx={classes.error_message}>
                {t(loginHomeAddressErrors?.zipCode, {
                  defaultValue: loginHomeAddressErrors?.zipCode,
                })}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginHomeAddress;

LoginHomeAddress.propTypes = {
  handleChange: PropTypes.func,
};
